import { Col, Row, Input, Form, Select, Modal } from 'antd';

import { PlusOutlined } from '@ant-design/icons';
import {
	useAddMaterialOrderMutation,
	useGetMaterialOrdersQuery,
} from '../../../redux/api/material';
import MaterialOrdersTable from '../../../components/MaterialOrdersTable';
import { OrderMaterial } from '../../../interfaces/Material.Interface';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import type { SearchProps } from 'antd/es/input';

import Header from '../../../components/Header';

import { Link } from 'react-router-dom';
import NewMaterialOrderForm from '../../../components/MaterialOrder/NewMaterialOrderForm.tsx';

interface MaterialOrderQuery {
	page?: number;
	search?: string;
	ordering?: string;
}

const { Search } = Input;

function MaterialOrders() {
	const location = useLocation();
	const navigate = useNavigate();

	const [showNewMaterialOrderForm, setShowNewMaterialOrderForm] =
		useState(false);

	const queryParams = new URLSearchParams(location.search);
	const currentPageUrl = Number(queryParams.get('page')) || 1;
	const searchUrl = queryParams.get('search') || '';
	const ordering = queryParams.get('ordering') || '';

	const materialQuery: MaterialOrderQuery = {};

	if (currentPageUrl) {
		materialQuery.page = currentPageUrl;
	}

	if (searchUrl) {
		materialQuery.search = searchUrl;
	}

	if (ordering && ordering !== '') {
		materialQuery.ordering = ordering;
	}

	const [addMaterialOrder] = useAddMaterialOrderMutation();

	const { data, isLoading } = useGetMaterialOrdersQuery(materialQuery, {
		refetchOnFocus: true,
		refetchOnMountOrArgChange: true,
	});
	const [materialOrders, setMaterialOrders] = useState<OrderMaterial[]>([]);
	const [pageReady, setPageReady] = useState(false);

	const [currentSearch, setCurrentSearch] = useState<string>(searchUrl);
	const [currentPage, setCurrentPage] = useState<number>(currentPageUrl);

	const [total, setTotal] = useState<number>(0);

	const onSearch: SearchProps['onSearch'] = async (value: string) => {
		queryParams.set('search', value);
		queryParams.set('page', '1');
		setCurrentSearch(value);
		navigate({ search: queryParams.toString() });
		setCurrentPage(1);
	};

	const pageChanged = async (page: number) => {
		queryParams.set('page', page.toString());
		navigate({ search: queryParams.toString() });
		setCurrentPage(page);
	};

	useEffect(() => {
		if (data) {
			setMaterialOrders(data.results as OrderMaterial[]);
			setTotal(data.count ? data.count : 0);
		}
	}, [data]);

	useEffect(() => {
		if (!isLoading && data) {
			setPageReady(true);
		}
	}, [data, isLoading]);

	return (
		<main
			data-testid="page-fastlane-material-orders"
			data-ready={pageReady ? 'true' : 'false'}
		>
			<Header
				title="Material Orders"
				showOnClickButton={true}
				handleOnClick={async () => {
					setShowNewMaterialOrderForm(true);
				}}
				buttonText={'Add Material Order'}
				icon={<PlusOutlined />}
				breadcrumbItems={[
					{
						title: <Link to="/">Home</Link>,
					},
					{
						title: 'Material Orders',
					},
				]}
			/>
			<Row>
				<Col span={24}>
					<div className="search-input">
						<Search
							placeholder="Search"
							onSearch={onSearch}
							defaultValue={currentSearch}
							style={{ width: '100%' }}
						/>
					</div>
					<MaterialOrdersTable
						data={materialOrders}
						isLoading={isLoading}
						total={total}
						currentPage={currentPage}
						onChangePage={(page: number) => {
							pageChanged(page);
						}}
						onSort={(column: string | undefined) => {
							if (column) {
								queryParams.set('ordering', column);
							} else {
								queryParams.delete('ordering');
							}
							navigate({ search: queryParams.toString() });
						}}
					/>
				</Col>
			</Row>

			{showNewMaterialOrderForm ? (
				<Modal
					open={showNewMaterialOrderForm} // Use state to control visibility
					title="New Material Order"
					footer={null}
					onCancel={() => setShowNewMaterialOrderForm(false)} // Close modal on cancel
				>
					<NewMaterialOrderForm
						handleSubmit={async (vendor_id) => {
							const response =  await addMaterialOrder({
								vendor: vendor_id,
								// requisition_number: null,
								// create_purchase_order: false,
								// total_amount: 0.0,
								status: 'Draft',
							})
								.unwrap()


							setShowNewMaterialOrderForm(false);
							navigate(`/material/orders/add/${response.id}`);
						}}
					/>
				</Modal>
			) : null}
		</main>
	);
}

export default MaterialOrders;
